export default {
  quote_id: 0,
  quote_number: '',
  policy_number: '',
  travelDetails: {
    travel_plan: null,
    coverage_type: '',
    destination: ''
  },
  first_name: '',
  last_name: '',
  email_address: '',
  age_range: null,
  departure_date: '',
  return_date: '',
  duration: 0,
  num_of_travellers: '',
  travellers: [],
  total_value: 0,
  total_levy: 0,
  premium: '',
  levy: '',
  base: ''
}